"use strict";

var promises = require("../../lib/promises");
exports.Files = Files;
function Files() {
  function read(uri) {
    return promises.reject(new Error("could not open external image: '" + uri + "'\ncannot open linked files from a web browser"));
  }
  return {
    read: read
  };
}